<template>
  <ScriptVimeoPlayer
    :id="id"
    trigger="immediate"
    :root-attrs="{
      style: {
        width: 'auto',
      },
    }"
    :vimeo-options="{
      byline: false,
      portrait: false,
      title: false,
      dnt: true,
    }"
    @play="setState('playing')"
    @pause="setState('paused')"
    @ended="setState('ended')"
    @loaded="onLoaded"
  />
</template>

<script lang="ts" setup>
import type Vimeo from '@vimeo/player'

defineProps<{
  id: number
}>()

let player: Vimeo | null = null

const { setState } = useVideoTracking('vimeo', {
  getTitle: () => player?.getVideoTitle(),
  getCurrentTime: () => player?.getCurrentTime(),
  getDuration: () => player?.getDuration(),
  getVideoUrl: () => player?.getVideoUrl(),
})

function onLoaded(_event: Vimeo.LoadedEvent, playerInstance: Vimeo) {
  player = playerInstance
  setState('loaded')
}
</script>
